module.exports = __webpack_public_path__ + "img/shopping.2de19b07.png";